<chart-details-layout
  [chartDetails]="chartDetails"
  [isLoading]="isLoading"
  [showFormButtons]="showFormButtons"
  (save)="onSaveSettings()"
  (cancel)="onRevertSettings()"
>
  <users-sessions-chart chart [showTitle]="false"></users-sessions-chart>
  <base-details
    detailsComponent
    *ngIf="!isLoading"
    [chartDetails]="chartDetails"
    [generalSettings]="config?.generalSettings"
    (generalSettingsChange)="onGeneralSettingsChange($event)"
    (chartTypeChange)="localSelectedChartType = $event"
  >
    <div #filterContent>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group input-group has-feedback" style="position: relative;">
            <label
              class="control-group input-group-addon"
              for="selectTimePeriod"
              >Time Period
                <button class="info-btn"
                        type="button"
                        [attr.title]="info('timePeriod')"
                        (click)="onInfoClick($event, 'timePeriod')">
                    i
                </button>
              </label
            >
            <select
              id="selectTimePeriod"
              name="selectTimePeriod"
              [(ngModel)]="selectedTimePeriod"
              class="form-control"
              (click)="hideTooltip()"
            >
              <option value="" [selected]="selectedTimePeriod === ''">
                -- Select Time Period --
              </option>
              <option
                *ngFor="let period of hourlyTimePeriods"
                [value]="period.value"
              >
                {{ period.display }}
              </option>
            </select>

            <div class="click-tooltip"
                 *ngIf="isTooltipVisible('timePeriod')"
                 (click)="hideTooltip()">
              {{ info('timePeriod') }}
            </div>
          </div>
          <line-chart-label-helper
            [selectedChartType]="localSelectedChartType"
            [selectedTimePeriod]="selectedTimePeriod"
            [info]="info.bind(this)"
            [onInfoClick]="onInfoClick.bind(this)"
            [isTooltipVisible]="isTooltipVisible.bind(this)"
            [hideTooltip]="hideTooltip.bind(this)"
          ></line-chart-label-helper>
        </div>
        <div class="col-lg-12">
          <div class="form-group input-group has-feedback" style="position: relative;">
            <label
              class="control-group input-group-addon"
              for="selectExpirationPeriod"
              >Expiration Time Period
                <button class="info-btn"
                        type="button"
                        [attr.title]="info('expirationTimePeriod')"
                        (click)="onInfoClick($event, 'expirationTimePeriod')">
                    i
                </button>
              </label
            >
            <select
              id="selectExpirationPeriod"
              name="selectExpirationPeriod"
              [(ngModel)]="sessionExpirationPeriod"
              class="form-control"
              (click)="hideTooltip()"
            >
              <option value="" [selected]="sessionExpirationPeriod === ''">
                -- Select Expiration Time Period --
              </option>
              <option
                *ngFor="let expirationPeriod of expirationTimePeriods"
                [value]="expirationPeriod.value"
              >
                {{ expirationPeriod.display }}
              </option>
            </select>

            <div class="click-tooltip"
                 *ngIf="isTooltipVisible('expirationTimePeriod')"
                 (click)="hideTooltip()">
              {{ info('expirationTimePeriod') }}
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="form-group input-group has-feedback" style="position: relative;">
            <label
              class="control-group input-group-addon"
              for="selectPermission"
              >User Permission
                <button class="info-btn"
                        type="button"
                        [attr.title]="info('userPermission')"
                        (click)="onInfoClick($event, 'userPermission')">
                    i
                </button>
              </label
            >
            <select
              id="selectPermission"
              name="selectPermission"
              [(ngModel)]="selectedPermission"
              class="form-control"
              (click)="hideTooltip()"
            >
              <option value="" [selected]="selectedPermission === 0">
                -- Select Permission --
              </option>
              <option
                *ngFor="let permission of userPermissions"
                [value]="permission.value"
              >
                {{ permission.display }}
              </option>
            </select>

            <div class="click-tooltip"
                 *ngIf="isTooltipVisible('userPermission')"
                 (click)="hideTooltip()">
              {{ info('userPermission') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </base-details>
</chart-details-layout>
